import { BreadcrumbGroupProps } from '@amzn/awsui-components-react/polaris/breadcrumb-group';
import { atom } from 'recoil';

export const key = 'breadcrumbsState';

export const initialState = [];

export const state = atom<BreadcrumbGroupProps.Item[]>({
    key,
    default: initialState,
});
